export enum GeneroEnum { NONBIN, MALE, FEMALE }

const idsGeneros = new Map<GeneroEnum, string>();

idsGeneros.set(GeneroEnum.NONBIN, "NONBIN");
idsGeneros.set(GeneroEnum.MALE, "MALE");
idsGeneros.set(GeneroEnum.FEMALE, "FEMALE");

const nombresGeneros = new Map<GeneroEnum, string>();

nombresGeneros.set(GeneroEnum.NONBIN, "No binario");
nombresGeneros.set(GeneroEnum.MALE, "Masculino");
nombresGeneros.set(GeneroEnum.FEMALE, "Femenino");

export const obtenerIdGenero: (genero: GeneroEnum) => string = genero => idsGeneros.get(genero) ?? "";
export const obtenerNombreGenero: (genero: GeneroEnum) => string = genero => nombresGeneros.get(genero) ?? "";

export const obtenerIdsGenero: () => Array<[GeneroEnum, string]> = () => Array.from(idsGeneros.entries());
export const obtenerNombresGenero: () => Array<[GeneroEnum, string]> = () => Array.from(nombresGeneros.entries());
